const retrieveParamsFromUrl = (url: string) => {
  // ex url : http://localhost:3000/play/shopify/account#customer_id=${customer_id}#shop=raphtestloyoly.myshopify.com
  // http://localhost:3000/play/shopify/section-referral#customer_id=6399397953616%23shop=raphtestloyoly.myshopify.com
  const { searchParams } = new URL(document.URL)
  const blocks = url.split('#')
  let customerId = ''
  let shopName = ''
  const langCode = searchParams.get('langcode')
  if (blocks.length > 1) customerId = blocks[1].replace('customer_id=', '')
  if (blocks.length > 2) shopName = blocks[2].replace('shop=', '')
  if (searchParams.has('customer_id')) {
    customerId = searchParams.get('customer_id') || ''
  }
  if (searchParams.has('shop')) {
    shopName = decodeURIComponent(searchParams.get('shop') || '') || ''
  }

  const langSuffix = searchParams.get('langSuffix')
  const origin = searchParams.get('origin')

  return {
    customerId,
    shopName,
    langCode,
    langSuffix,
    origin
  }
}

export default defineNuxtRouteMiddleware(async (to) => {
  useStoreApp().isAccountContext = true

  const { fetchLocales } = useStoreStore()
  const { authenticateFromStore } = useStoreAuth()

  const { customerId, shopName, langCode, langSuffix, origin } = retrieveParamsFromUrl(to.fullPath)

  const company = await useStoreStore().fetchStoreFromName(shopName)
  useStoreStore().langCode = langCode
  useStoreStore().langSuffix = langSuffix
  useStoreStore().origin = origin
  if (company?.company_id) {
    const companyId = company.company_id

    useStoreApp().companyId = companyId

    if (customerId) {
      await authenticateFromStore(companyId, customerId)
    } else {
      await authenticateFromStore(companyId)
    }
    useStoreCompany().fetchCompany()
    await fetchLocales()
  } else {
    return navigateTo('https://www.loyoly.io', { external: true })
  }
})
